module.exports = __webpack_public_path__ + "static/img/yinliangjia.7190295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yinliangjia.png
// module id = YhdP
// module chunks = 24